<template>
  <div class="playerContent" style="margin: 0; padding: 0; overflow: hidden" data-course-id="2403">
    <div v-if="openInfo != {}" class="live">
      <div class="left">
        <div class="video">
          <div id="livePlayer" style="width: 100%; height: 100%; position: relative" />
        </div>
        <div class="line"><i class="iconfont icon-a-zu335" />课程列表</div>
        <div class="list">
          <a v-for="(value, index) in kechengList" :key="index" class="item" :class="{ on: id == value.id }"
            @click="check(value)">
            <div class="item-line" />
            <div class="icon">{{ index + 1 }}</div>
            <div class="item-title oneEllipsis">{{ value.liveChapterName }}</div>
            <div v-if="value.liveCourseStatus == 1" class="tag tag2">直播中</div>
            <div v-else-if="value.liveCourseStatus == 0" class="tag tag2">未开始</div>
            <div v-else class="tag tag1">回放</div>
          </a>
        </div>
      </div>
      <div class="midst">
        <div class="midst-left">
          <i class="fa fa-angle-left" aria-hidden="true" />
        </div>
        <div class="doc">
          <div class="doc-title">
            <div class="doc-left">
              <div class="icon">
                <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/PlayerPublic-icon1.png" />
              </div>
              <div class="name">{{ liveDetail.chapterName }}</div>
            </div>

            <div class="detail-ter flex-c">
              <div style="cursor: pointer;" v-if="liveDetail" @click="terDio = true" class="ter-list">
                <div class="terbox">
                  <el-image class="ter-img" :src="liveDetail ? liveDetail.teacherPortrait : ''" fit="cover" />
                </div>
                <span class="ter">讲师：{{ liveDetail ? liveDetail.teacherName : '' }}</span>
              </div>
            </div>
          </div>

          <!-- CC直播 -->
          <div id="drawPanel" :class="fullScreenInfo ? 'full_screen' : ''">
            <!-- <div class="iconfont icon-quanping1" @click="fullScreen" />
            <div :id="'liveLog'">
              <img :src="copyright.videoLogo" style="object-fit: contain" />
            </div>
            <div v-if="openType == 2" :id="'clxliveLog'">
              <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/jx/xlcbg.png" style="object-fit: contain" />
            </div> -->
          </div>
        </div>
        <div class="midst-right">
          <i class="fa fa-angle-right" aria-hidden="true" />
        </div>
      </div>
      <div class="right">
        <div class="right-title">聊天</div>
        <div id="msg-list" ref="msgList" class="msg-list">
          <div v-for="(value, index) in chatList" :key="index">
            <!-- 自己发送 -->
            <div v-if="value.username == nickName" class="msg-item my-msg">
              <div class="name">{{ value.username }}</div>
              <div class="msg">{{ value.msg }}</div>
            </div>
            <!-- 其他人 -->
            <div v-else class="msg-item">
              <div class="name">{{ value.username }}</div>
              <div class="msg">{{ value.msg }}</div>
            </div>
          </div>
        </div>

        <div class="sendMsg">
          <div class="block">
            <textarea id="chatinput" v-model="content" placeholder="和大家一起讨论一下吧..." />
            <div class="sendMsg-btn" @click="clickSend">发送</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


import { getInfo, getDomain, getToken } from "@/api/cookies";
// import { getLbClassCourseById } from "@/api/home";
// import ratingPopup from "@/components/ratingPopup.vue";
import format from "date-fns/format";
// import { newWebSocket } from "@/common/utils/newWebSocket.js";
// import {
//   onLineLiveCourseDataSendBatch,
//   courseCheckPlay,
//   judgeIsComment,
// } from "@/api/know";
// import terDioShow from '@/components/Know/terDioShow.vue'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import Vue from "vue";
export default {
  components: {
    // ratingPopup,
    //  terDioShow
  },
  props: ["courseId", "id", "showId"],
  data() {
    return {
      content: "",
      nickName: "",
      showTip: true,
      terDio: false,
      pageNum: 1,
      stateTimes: 0,
      pageSize: 10,
      openInfo: {},
      userInfo: {},
      chatList: [],
      kechengList: [],
      openInfoKe: {},
      player: {},
      timer: null,
      DWLive: null,
      liveInfo: {},
      joinTime: "",
      fullScreenInfo: false,
      isfullscreen: false,
      copyright: null,
      timeStamp: null,
      ratingPopupShow: false,
      judgeCommen: null,
      watchTime: 0,
      lookDeatil: null,
      showLookDetail: false,
      marquee: null,
      openType: 1,
      currentPlayTimeBatch: [],
      liveDetail: {},
    };
  },

  created() {
    this.copyright = getDomain();
  },
  async mounted() {

    this.userInfo = getInfo();
    await homeClient
      .getCourseDataLiveVo({
        playId: this.id,
        teachingMethod: 1,
      })
      .then(async (res) => {
        this.liveDetail = res.data;
        this.initPublicChat();
        this.getCourseList();
      });

  },

  methods: {
    
    isok() {
      this.terDio = false
    },
    closeLook() {
      this.showLookDetail = false;
    },
    setLiveInfo(res) {
      this.liveInfo = res;
    },
    clearTimeInterval() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
   async getCourseList() {
       await homeClient
        .queryCourseJxyDetails({
          courseId: this.courseId,
        })
        .then((res) => {
          this.kechengList = res.data.liveList;
        });
    
    },
    check(item) {
      const userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
      if (this.showId == item.id) {
        return;
      }
      const sub = {
        id: item.id,
        classId: this.classId,
        classProductLine: this.classProductLine,
        chapterName: item.title,
        typekc: this.typekc,
      };
      const data = Vue.prototype.export(sub);
      if (item.isLive == 0) {
        this.$message.error("课程还未到开播时间");
        return;
      }
      if (item.isLive == 2) {
        this.$message.error("课程直播结束");
        return;
      }

    },
    // 发送聊天
    clickSend() {
      if (this.content == "") {
        this.$message.error("请输入内容！");
      } else {
        DWLive.sendPublicChatMsg(this.content); // 发送公聊
        this.content = "";
      }
    },
    // 初始化聊天
    initPublicChat() {
      const token = getToken();
      const that = this;
      const query = this.getUrlParams(this.liveDetail.limitPlayLink);

      const roomId = query.roomid;
      that.nickName = that.userInfo.userId + "-" + that.userInfo.nickName;
      console.log(that.nickName,'that.nickName');
      
      DWLive.init({
        userid: "41A331E332E32281", // 必须参数
        roomid: roomId, // 必须参数
        pcH5Live: true,
        viewername: that.nickName,
        viewertoken: '123',
      });
      DWLive.onLiveStart = () => {
        window.location.reload();
        that.clearTimeInterval();
        that.timeInterval();
      };
      DWLive.onLiveEnd = () => {
        DWLive.switchFullScreen(false);
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.fullScreenInfo = false;

        if (that.judgeCommen == "false") {
          const fullscreenElement = document.fullscreenElement;
          if (fullscreenElement) {
            /* 退出全屏 */
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
            this.fullScreenInfo = false;
          }
          that.ratingPopupShow = true;
        }
        that.clearTimeInterval();
      };
      // 接收公聊
      DWLive.onPublicChatMessage = function (j) {
        const msgObg = JSON.parse(j);
        that.chatList = that.chatList.concat(msgObg);
        // 滚动到底部
        that.$nextTick(function () {
          var msgList = this.$refs.msgList;
          msgList.scrollTo({
            // 滚动动画
            top: msgList.scrollHeight,
            behavior: "smooth",
          });
        });
      };
      // setInterval(this.timeInterval,1000)
      DWLive.onLiveTime = (res) => this.setLiveInfo(res);
      this.DWLive = DWLive;
      this.clearTimeInterval();
      this.timeInterval();

    },
    timeInterval() {
      var currentPlayTime = format(new Date(), "yyyy-MM-dd HH:mm:ss")
      this.currentPlayTimeBatch.push(currentPlayTime)
      let that = this
      var batchSize = 30
      if ((this.currentPlayTimeBatch.length % batchSize) == 0 && this.currentPlayTimeBatch.length > 0) {
        that.sendTimePointBatch()
      }

      this.timer = setTimeout(this.timeInterval, 1000);
    },
    getUrlParams(urlStr) {
      if (typeof urlStr == "undefined") {
        // 获取url中"?"符后的字符串
        var url = decodeURI(location.search);
      } else {
        var url = "?" + urlStr.split("?")[1];
      }
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substring(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    closeRatingPopup() {
      this.ratingPopupShow = false;
    },

  },
};
</script>

<style lang="less" scoped>
.playerContent {
  background-color: #dbdbdb;
  height: 80vh;
  width: 100%;

  .live {
    display: flex;
    height: 100%;

    .left {
      width: 280px;
      height: 100%;

      .video {
        width: 280px;
        height: 187px;
        background-color: #fff;
      }

      .line {
        width: 280px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
        color: #27323f;
        background: #f1f7f5;
      }

      .list {
        width: 280px;
        // height: 669px;
        height: calc(80vh - 44px - 200px);
        background: #fff;
        position: relative;
        padding-top: 10px;
        overflow-y: auto;
        overflow-x: hidden;

        .item {
          width: 280px;
          height: 36px;
          background: #ffffff;
          cursor: pointer;
          padding-left: 16px;
          position: relative;
          padding-right: 6px;
          margin-bottom: 5px;
          display: block;

          .item-line {
            height: 36px;
            width: 1px;
            background-color: #dddfdf;
            position: absolute;
            z-index: 1;
            left: 27px;
            top: 12px;
          }

          .icon {
            width: 23px;
            height: 23px;
            border: 1px solid #dfe1e1;
            border-radius: 50%;
            color: #494949;
            font-size: 12px;
            float: left;
            text-align: center;
            line-height: 21px;
            margin-top: 6px;
            z-index: 2;
            background-color: #fff;
            position: relative;
          }

          .item-title {
            color: #494949;
            font-size: 14px;
            line-height: 36px;
            margin-left: 10px;
            float: left;
            width: 149px;
          }

          .tag {
            float: right;
            height: 18px;
            border-radius: 9px;
            text-align: center;
            font-size: 14px;
            line-height: 16px;
            padding: 0 8px;
            margin-top: 9px;
            margin-right: 6px;
          }

          .tag1 {
            border: 1px solid #f57d39;
            color: #f57d39;
          }

          .tag2 {
            border: 1px solid #c9c9c9;
            color: #c9c9c9;
          }

          &:hover {
            background: #00a1e9;
            color: #fff;

            .item-title {
              color: #fff;
            }

            .icon {
              border: 1px solid #fff;
              color: #fff;
              background: #00a1e9;
            }

            .item-line {
              background-color: #fff;
            }

            .tag {
              border: 1px solid #fff !important;
              color: #fff !important;
            }
          }
        }

        .item:hover {
          background: #00a1e9;
          color: #fff;
        }

        .child-item {
          width: 280px;
          height: 36px;
          background: #ffffff;
          cursor: pointer;
          padding-left: 16px;
          position: relative;
          padding-right: 6px;
          margin-bottom: 5px;
          display: block;

          .item-line {
            height: 48px;
            width: 1px;
            background-color: #dddfdf;
            position: absolute;
            z-index: 1;
            left: 27px;
            top: 0;
          }

          .icon {
            width: 11px;
            height: 11px;
            border: 1px solid #dfe1e1;
            border-radius: 50%;
            color: #494949;
            font-size: 12px;
            float: left;
            text-align: center;
            line-height: 21px;
            margin-top: 12px;
            z-index: 2;
            background-color: #fff;
            position: relative;
            margin-left: 6px;
          }

          .item-title {
            color: #494949;
            font-size: 14px;
            line-height: 36px;
            margin-left: 10px;
            float: left;
            width: 149px;
          }

          .tag {
            float: right;
            height: 18px;
            border-radius: 9px;
            text-align: center;
            font-size: 14px;
            line-height: 16px;
            padding: 0 8px;
            margin-top: 9px;
            margin-right: 6px;
          }

          .tag1 {
            border: 1px solid #f57d39;
            color: #f57d39;
          }

          .tag2 {
            border: 1px solid #c9c9c9;
            color: #c9c9c9;
          }

          &:hover {
            background: #00a1e9;
            color: #fff;

            .item-title {
              color: #fff;
            }

            .icon {
              border: 1px solid #fff;
              color: #fff;
              background: #00a1e9;
            }

            .item-line {
              background-color: #fff;
            }

            .tag {
              border: 1px solid #fff !important;
              color: #fff !important;
            }
          }
        }

        .on {
          background: #00a1e9;
          color: #fff;

          .item-title {
            color: #fff;
          }

          .icon {
            border: 1px solid #fff;
            color: #fff;
            background: #00a1e9;
          }

          .item-line {
            background-color: #fff;
          }

          .tag {
            border: 1px solid #fff !important;
            color: #fff !important;
          }
        }
      }
    }

    .midst {
      height: 100%;
      width: calc(100% - 560px);
      padding: 0 10px;

      .doc {
        width: 100%;
        // height: calc(944px - 44px);
        height: calc(100% - 44px);
        float: left;
        position: relative;

        .doc-title {
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .doc-left {
            display: flex;
            align-items: center;

            .icon {
              width: 21px;
              height: 18px;
              margin-right: 8px;
            }

            .name {
              color: #7b8196;
            }
          }

          .goBack-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #00a2e9;
            border-radius: 12px;
            font-size: 12px;
            color: #00a2e9;
            line-height: 22px;
            width: 110px;
            cursor: pointer;

            .btn-icon {
              margin-right: 5px;
            }
          }
        }

        .prompt {
          height: 40px;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding: 0 50px;
          position: absolute;
          top: 58px;
          z-index: 99;

          .textWrap {
            display: flex;
            align-items: center;
            color: #f15817;

            .img {
              margin-right: 8px;
            }
          }

          .prompt-close {
            color: #a8abbe;
            cursor: pointer;
          }
        }

        #drawPanel {
          // height: 856px;
          // height: 90% !important;
          background-color: #ffffff;
          position: relative;

          .icon-quanping1 {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
          }

          #liveLog {
            position: absolute;
            right: 50px;
            bottom: 50px;

            img {
              height: 40px;
            }
          }

          #clxliveLog {
            position: absolute;
            left: 50px;
            top: 50px;

            img {
              height: 40px;
            }
          }

        }
      }
    }

    .right {
      width: 280px;
      height: 100%;

      .right-title {
        height: 44px;
        border: 1px solid #eeeeee;
        line-height: 44px;
        text-align: center;
        color: #27323f;
        font-size: 14px;
        background-color: #ffffff;
      }

      .msg-list {
        width: 280px;
        // height: 80%;
        height: calc(100% - 144px);
        padding: 15px;
        background-color: #ffffff;
        overflow-y: auto;
        overflow-x: hidden;

        .msg-item {
          overflow: hidden;
          margin-bottom: 30px;

          .name {
            font-size: 14px;
            color: #343434;
            margin-bottom: 5px;
          }

          .msg {
            max-width: 204px;
            background: #e9e9e9;
            border-radius: 0px 10px 10px 10px;
            font-size: 12px;
            color: #343434;
            padding: 10px;
            float: left;
          }
        }

        .my-msg {
          .name {
            font-size: 16px;
            color: #343434;
            margin-bottom: 5px;
            text-align: right;
          }

          .msg {
            max-width: 204px;
            background: #c6eeff;
            border-radius: 10px 0px 10px 10px;
            font-size: 14px;
            color: #343434;
            padding: 10px;
            float: right;
          }
        }
      }

      .sendMsg {
        height: 80px;
        margin-top: 12px;
        background-color: #ffffff;
        padding: 10px;

        .block {
          width: 260px;
          height: 100%;
          position: relative;

          #chatinput {
            width: 100%;
            height: 100%;
            border: none;
            background-color: #eeeeee;
            border-radius: 10px;
            padding: 10px;
          }

          .sendMsg-btn {
            width: 46px;
            height: 26px;
            border-radius: 4px;
            background-color: #00a2e9;
            text-align: center;
            line-height: 26px;
            color: #ffffff;
            font-size: 14px;
            position: absolute;
            right: 10px;
            bottom: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.oneEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.full_screen {
  overflow: hidden !important;
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh !important;
  z-index: 99999;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}

/* 讲师 */
.detail-ter {
  flex-shrink: 0;

  .ter {
    color: #fff;
  }
}

.lookterDio {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: rgba(0, 0, 0, .5);
}
</style>